var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"entNewFavorite"},[_c('v-uni-view',{staticClass:"entNewFavorite-outer"},[_c('v-uni-image',{attrs:{"src":_vm.formdata.d.logo}}),_c('v-uni-view',{staticClass:"entNewFavorite-outer-title"},[_c('v-uni-text',[_vm._v(_vm._s(_vm.formdata.d.title))])],1),_c('v-uni-view',{class:_vm.status ? 'favorite-selected' : 'favorite',on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.toggle).apply(void 0, arguments)
}}})],1)],1)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }